export default __webpack_public_path__ + "img/logout.c6a18b67.svg";